<script>
	/**
	 * This component allows the handling of clicks outside of a container:
	 * - The element must contain the current focused element before it will fire the provided callback on external click
	 * -- Should be primarily used in dialogs (modals, etc.) that contains an element that has received focus on open
	 * - Does not require a full screen overlay (e.g. modal util)
	 * - Uses mousedown event to capture target before focus has shifted
	 * -- If callback not fired as expected on mobile devices, bind handler to `touchstart` and `dragstart events`
	 * - Blur/focusout events can fire too frequently
	 * - Allows exceptions to be provided (e.g. journey step elements)
	 */

	module.exports = {
		props: {
			exceptions: {
				required: false,
				type: Array
			}
		},
		data() {
			return {
				isCurrentlyFocused: false,
				boundHandler: undefined
			};
		},
		methods: {
			elementContains(element, child) {
				if (element === child) {
					return true;
				}

				if (child === undefined || child === null) {
					return false;
				}

				return this.elementContains(element, child.parentNode);
			},
			handler(event) {
				const isCurrentlyFocused = this.elementContains(this.$el, document.activeElement);
				const aboutToBeFocused = this.elementContains(this.$el, event.target || event.currentTarget);

				if (!aboutToBeFocused && (this.isCurrentlyFocused || isCurrentlyFocused)) {
					this.isCurrentlyFocused = false;

					let clickedException = false;
					const exceptions = this.exceptions;
					if (Array.isArray(exceptions)) {
						clickedException = exceptions.some(exception => this.elementContains(exception, event.target || event.currentTarget));
					}

					if (!clickedException) {
						this.$emit('clicked-elsewhere');
					}
				} else {
					this.isCurrentlyFocused = aboutToBeFocused || isCurrentlyFocused;
				}
			}
		},
		mounted() {
			document.addEventListener('mousedown', this.handler);
		},
		beforeDestroy() {
			document.removeEventListener('mousedown', this.handler);
		}
	};
</script>
<template>
	<div>
		<slot></slot>
	</div>
</template>
